import { IAuthToken } from '@interticket/core';

export class AuthToken implements IAuthToken {

  readonly access_token: string;
  readonly refresh_token: string;
  readonly token_type: string;
  readonly expires_in: number;
  readonly scope: string;

  constructor(iAuthToken: IAuthToken) {
    this.access_token = iAuthToken.access_token;
    this.refresh_token = iAuthToken.refresh_token;
    this.token_type = iAuthToken.token_type;
    this.expires_in = +iAuthToken.expires_in || null;
    this.scope = iAuthToken.scope;
  }

}
